import { ApiError } from '~/api/errors';

/** i18n suffix selecting the message under a tab's `preview.errors.*` group. */
export type PreviewErrorKey =
  | 'unauthorized'
  | 'forbidden'
  | 'notFound'
  | 'server'
  | 'network'
  | 'generic';

/**
 * Map a failed preview fetch to a specific message key so the inline error
 * state can explain the cause (auth / permission / not-ready / server / network)
 * instead of one generic line. Anything we can't classify falls back to
 * 'generic'. Mirrors the categories in `ApiError.code`.
 */
export function previewErrorKey(error: unknown): PreviewErrorKey {
  if (error instanceof ApiError) {
    switch (error.code) {
      case 'UNAUTHORIZED':
        return 'unauthorized';
      case 'FORBIDDEN':
        return 'forbidden';
      case 'NOT_FOUND':
        return 'notFound';
      case 'SERVER_ERROR':
        return 'server';
      case 'NETWORK_ERROR':
      case 'TIMEOUT':
        return 'network';
      default:
        return 'generic';
    }
  }
  return 'generic';
}
